export const htmlLangFor = (i18nLanguage: string): "nb" | "en" => (i18nLanguage.startsWith("no") ? "nb" : "en");

export const declareDocumentLanguage = (i18nLanguage: string) => {
  document.documentElement.lang = htmlLangFor(i18nLanguage);
};
